<template>
  <div class="content">
    <el-dialog
      :visible.sync="answerRegisterStatus.registerDialogVisible"
      class="register"
      @close="answerRegisterStatus.answerDialogVisible = false"
    >
      <div class="register-main">
        <img
          class="register-bg"
          src="@/assets/pcImg/other/register.png"
          alt="图片"
        />
        <img
          class="register-close"
          src="@/assets/pcImg/other/close.png"
          alt="图片"
          @click="registerClose"
        />
        <div class="register-calendar">
          <div class="register-calendar-title">
            <span></span>
            <div>आज सफलतापूर्वक लॉग इन किया गया</div>
            <span></span>
          </div>
          <div class="register-calendar-main">
            <div
              class="register-calendar-week"
              v-for="item in weekList"
              :key="item"
            >
              <div>{{ item }}</div>
            </div>
            <div
              class="register-calendar-day"
              v-for="(item, index) in answerRegisterStatus.dateList"
              :key="index"
            >
              <div
                :class="
                  item.bgColor
                    ? 'register-calendar-day-item lastday'
                    : 'register-calendar-day-item'
                "
              >
                <span v-if="!item.isRmb">{{ item.day }}</span>
                <img
                  v-else
                  class="rmb"
                  src="@/assets/pcImg/other/￥.png"
                  alt="图片"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["answerRegisterStatus"],
  data() {
    return {
      weekList: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    };
  },
  created() {
    console.log("111", this.answerRegisterStatus);
  },
  methods: {
    changeAnswerIndex(index, item) {
      this.$emit("changeAnswerIndex", index);
      this.optionIds = item.id;
    },
    registerClose() {
      this.$emit("registerClose");
    },
  },
};
</script>

<style scoped>
/* 新增 */
.content >>> .el-dialog__header {
  display: none;
}
.content /deep/ .el-dialog__body {
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 14px;
  padding-bottom: 0;
}
.content >>> .el-dialog {
  width: 375px;
}
.content /deep/.answerNone {
  display: none;
}
.register /deep/ .el-dialog__body {
  padding: 0;
}

/* 签到 */
.register-main {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0;
}
.register-bg {
  width: 100%;
}
.register-close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 10px;
  height: 10px;
  cursor: pointer;
}
.register-calendar {
  position: relative;
  top: -41.875px;
  width: 100%;
  min-height: 62.5px;
  background-color: #fff;
  border-radius: 24.375px 24.375px 0px 0px;
  opacity: 1;
}
.register-calendar-title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 41.875px;
}
.register-calendar-title > div {
  font-size: 13px;
  font-weight: bold;
  color: #ed6c4b;
  margin: 0 30px;
}
.register-calendar-title > span {
  width: 34px;
  height: 0px;
  opacity: 1;
  border: 1px solid #ec694d;
}
.register-calendar-main {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.register-calendar-week {
  width: 14.285%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 10px;
  margin-top: 10px;
  color: #000;
}
.register-calendar-day {
  width: 14.285%;
  height: 37.5px;
  line-height: 50px;
  text-align: center;
  font-size: 10px;
  margin-top: 5px;
  color: #000;
}
.register-calendar-day-item {
  width: 37.5px;
  height: 37.5px;
  background-color: #fff;
  border-radius: 5px;
  /* cursor: pointer; */
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lastday {
  color: #dac5c5;
  cursor: auto;
}
.rmb {
  width: 30px;
  height: 30px;
}
</style>
<style scoped>
@media only screen and (max-width: 666px) {
  .content >>> .el-dialog {
    transform: scale(0.9);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/answer-register.vue